import * as React from 'react'
import { Alert, Row, Col, Button } from 'reactstrap'
import { InputField, Checkbox } from '../../../../components'

type SignInModalProps = {
    data: ILoginInfo
    isLoading: boolean
    error?: IError
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
}
export const SignInForm: React.SFC<SignInModalProps> = (props: SignInModalProps) => {
    const { error, onSubmit, onChange, data, isLoading } = props
    const errorDetails: any = (error && error.details) ? error.details : {}

    return (
        <form name="loginForm" onSubmit={onSubmit}>
            {error && error.message && <Alert color="danger">{error.message}</Alert>}
            <InputField
                name="username"
                value={data.username}
                placeholder="Tài khoản"
                iconClass="icon-user"
                disabled={isLoading}
                autoFocus={true}
                error={errorDetails.username}
                onChange={onChange}
            />
            <InputField
                type="password"
                name="password"
                value={data.password}
                placeholder="Mật khẩu"
                iconClass="icon-lock"
                disabled={isLoading}
                error={errorDetails.password}
                onChange={onChange}
            />
            <Checkbox
                name="rememberMe"
                checked={data.rememberMe}
                text="Lưu thông tin"
                disabled={isLoading}
                onChange={onChange}
            />
            <Row>
                <Col className="text-right">
                    <Button type="submit" color="primary" disabled={isLoading}>
                        {isLoading && <i className="fa fa-spinner fa-spin" />}
                        {isLoading ? ' Đang đăng nhập...' : 'Đăng nhập'}
                    </Button>
                </Col>
            </Row>
        </form>)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/Auth/components/SignInForm.tsx